// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageLoading_loader__U_4Fv","overlayLoader":"PageLoading_overlayLoader__ZuX7A"};